import classNames from 'classnames';
import React from 'react';
import { white } from '../Styles/Colours';
import { Button, ButtonMode, ButtonSize, ButtonVariant } from './Button';
import styles from './DetailsPane.module.css';
import { ConfirmedIcon, FullViewIcon } from './Icons';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { usePermissions } from '../Hooks/usePermissions';
export var DetailsPaneState;
(function (DetailsPaneState) {
    DetailsPaneState[DetailsPaneState["ParentView"] = 0] = "ParentView";
    DetailsPaneState[DetailsPaneState["ChildView"] = 1] = "ChildView";
})(DetailsPaneState || (DetailsPaneState = {}));
export var DetailsPane = function (props) {
    var _a, _b;
    var containerStyles = classNames(styles.container, (_a = {},
        _a[styles.parentView] = props.state === DetailsPaneState.ParentView,
        _a[styles.childView] = props.state === DetailsPaneState.ChildView,
        _a));
    var leftPaneStyles = classNames(styles.leftPane);
    var parentContainerStyles = classNames(styles.parentContainer, (_b = {},
        _b[styles.noParentBackground] = props.noParentBackground,
        _b));
    var parentContent = props.state === DetailsPaneState.ParentView ? props.getParent() : props.getParentSummary();
    var permissions = usePermissions({
        stopMedications: MedicationsPermissions.StopMedications,
        prescribeMedicationsTakeHomeScript: MedicationsPermissions.PrescribeMedicationsTakeHomeScript,
        prescribeMedicationsEnrmcScript: MedicationsPermissions.PrescribeMedicationsEnrmcScript,
        prescribeMedicationsMedicationOrder: MedicationsPermissions.PrescribeMedicationsMedicationOrder,
        prescribeMedicationsMedicationHistory: MedicationsPermissions.PrescribeMedicationsMedicationHistory,
        prescribeComplementaryTherapyOrder: MedicationsPermissions.PrescribeComplementaryTherapyOrder
    });
    var canFinaliseMedication = [
        permissions.prescribeMedicationsTakeHomeScript,
        permissions.prescribeMedicationsEnrmcScript,
        permissions.prescribeMedicationsMedicationOrder,
        permissions.prescribeMedicationsMedicationHistory,
        permissions.prescribeComplementaryTherapyOrder
    ].filter(Boolean).length > 0;
    return (React.createElement("div", { className: containerStyles },
        React.createElement("div", { className: leftPaneStyles },
            props.state === DetailsPaneState.ChildView && (React.createElement("div", { className: styles.fullView },
                React.createElement(Button, { startIcon: React.createElement(FullViewIcon, null), onClick: function () { return props.onStateChange(DetailsPaneState.ParentView); }, testId: 'full-view', variant: ButtonVariant.light, mode: ButtonMode.text, size: ButtonSize.small, noShadowOnHover: true, className: styles.fullViewButton }, "Full view"))),
            React.createElement("div", { className: parentContainerStyles }, parentContent),
            props.state === DetailsPaneState.ChildView && canFinaliseMedication && (React.createElement("div", { className: styles.footer },
                React.createElement(Button, { testId: 'menuItem_FinaliseMedication', onClick: props.onFinaliseMedication, startIcon: React.createElement(ConfirmedIcon, { noPadding: true, size: '20', color: white }), width: '100%', tighterIcons: true, smallText: true, size: ButtonSize.small, style: { height: 32 } }, "Finalise Chart")))),
        props.state === DetailsPaneState.ChildView && React.createElement("div", { className: styles.rightPane }, props.getChild())));
};
